/* unplugin-vue-components disabled */
import Column from 'primevue/column'
import {DataTable, TableHead} from 'components/data-table'
import {downloadFile} from 'stores/files'
import {DropdownCalendar, DropdownCheckgroup} from 'components/filters'
import StatusBadge from 'pages/sh-files/status-badge.vue'
import {API2_TENANTS} from 'consts/api2'
import {Rest} from 'utils'
import $profile from 'stores/profile'

export default {
  components: {
    StatusBadge,
    DataTable,
    Column,
    DropdownCheckgroup,
    DropdownCalendar,
    TableHead
  },
  props: {
    count: {type: Number, default: 0},
    loading: {type: Boolean, default: false},
    files: {type: Array, default: () => []},
    allStatuses: {type: Array, default: () => []},
    allExts: {type: Array, default: () => []},
    skip: {type: Number, default: 0},
    highlight: {type: String, default: ''},
    tenant: {type: Object, required: true}
  },
  emits: ['select', 'update', 'upload'],
  data: function() {
    return {
      selected: new Set(),
      //
      // Filters
      //
      filter_statuses: [],
      filter_exts: [],
      filter_dates: [],
      //
      // Sorting
      //
      sort_field: 'created_at',
      sort_order: 1
    }
  },
  computed: {
    is_admin(){
      return $profile.is_admin
    },
    all_selected() {
      return this.selected.size === this.files.length
    },
    can_clear(){
      return this.filter_statuses.length || this.filter_dates?.length || this.filter_exts.length
    },
  },
  watch: {
    filter_exts(){
      this.onFilters({ext: this.filter_exts.join(',').toLowerCase()})
    },
    filter_statuses(){
      this.onFilters({status: this.filter_statuses.join(',').toLowerCase()})
    },
    filter_dates(){
      let period
      if (this.filter_dates.length === 2) {
        const range = $utils.format.normalizeDateRange(this.filter_dates)
        period = range.join(',')
      }
      this.onFilters({period})
    },
  },
  methods: {
    async onPage(ev){
      this.$emit('update', {skip: ev.first, limit: ev.rows})
    },
    async onSearch(name){
      this.$emit('update', {name, skip: 0})
    },
    async onFilters(ev){
      this.$emit('update', {...ev, skip: 0})
    },
    onSort(ev){
      this.sort_field = ev.sortField
      this.sort_order = ev.sortOrder
      this.$emit('update', {sort: `${this.sort_field}:${this.sort_order === 1 ? 'asc' : 'desc'}`})
    },
    async onDownload(file_id) {
      await downloadFile(file_id, `${API2_TENANTS}/${this.tenant.id}/files`)
    },
    async onCopyTaskResult(task_id) {
      try {
        const rest = new Rest()
        const res = await rest.get(`${API2_TENANTS}/${this.tenant.id}/files/result/${task_id}`)
        const stringedJson = JSON.stringify(res, null, 2)
        await $utils.copyText(stringedJson)
        $utils.toasts.message({
          class: 'success',
          message: `Task ${task_id} copied to clipboard`
        })
      }
      catch(err) {
        $utils.toasts.error(`Failed to copy task: ${err}`)
      }
    },
    async onResubmitTask(file_id) {
      const rest = new Rest()
      await rest.post(`${API2_TENANTS}/${this.tenant.id}/files/${file_id}/resubmit`)
      this.$emit('update')
    },
    onToggleHead() {
      if (this.selected.size > 0) this.selected = new Set()
      else this.selected = new Set(this.files.filter(file => !file.processing).map(file => file.id))
    },
    async clearFilters(){
      this.filter_exts = []
      this.filter_statuses = []
      this.filter_dates = []
      this.onFilters({
        ext: null,
        status: null,
        period: null
      })
    },
    onReset(){
      if (this.highlight) this.$refs.search.clearSearch()
      if (this.can_clear) this.clearFilters()
    }
  },
}
